"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.translationsNamespace = exports.defaultTranslations = void 0;
/* istanbul ignore file @preserve */

/**
 * DO NOT EDIT!
 * This file was autogenerated by npm script `localizations-codegen`.
 * Changes may cause incorrect behavior and will be lost when the file is regenerated.
 *
 * Run `npx localizations-codegen` to regenerate.
 */

const defaultTranslations = exports.defaultTranslations = {
  downloadQrCode: 'Download QR-code',
  generateQrCode: 'Generate QR-code',
  qrCodeOptionWithScanMeLabelOnBottom: "QR-code with 'Scan me' label on bottom",
  qrCodeOptionWithScanMeLabelOnTop: "QR-code with 'Scan me' label on top",
  qrCodeOptionWithoutScanMeLabel: "QR-code without 'Scan me' label",
  scanMe: 'SCAN ME'
};
const translationsNamespace = exports.translationsNamespace = 'qr-code-dialog';
